import {
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGIN_FAIL,
  ADMIN_LOGOUT
} from "../types/admin";

const user = JSON.parse(localStorage.getItem("admin"));

const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ADMIN_LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload,
        redirect: "/admin"
      };
    case ADMIN_LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
      case ADMIN_LOGOUT:
        return{
          isLoggedIn: false,
          user: null
        };
    default:
      return state;
  }
}
